import { useParams } from 'react-router';
import { JobDetailsView } from '../components/JobDetailsView';

export default function JobDetailPage() {
  const { jobId } = useParams<{ jobId: string }>();

  if (!jobId) return null;

  return <JobDetailsView jobId={jobId} />;
}
